import { useWLoading } from '@pequity/shared/ui';
import { type Router } from 'vue-router';

export const displayWLoading = (router: Router) => {
  const { loadingShow, loadingHide } = useWLoading();

  router.beforeEach((to, from, next) => {
    loadingHide('routeChange');

    if (from.name) {
      loadingShow({ id: 'routeChange' });
    }

    next();
  });

  router.afterEach(() => {
    loadingHide('routeChange');
  });
};
